module.exports = __webpack_public_path__ + "img/hr.2190a525.svg";